@if (label()) {
  <label class="form-field__label">
    {{ label() }}
  </label>
}

<ng-content />

@if (hint()) {
  <p class="form-field__hint">{{ hint() }}</p>
}

<app-form-error />
